import { Nullable } from 'utils/tsHelpers';
import { ExperimentTakeoverSource } from '../constants';

export type ExperimentTakeoverMetaData = {
  /** From which module are we opening the experiment takeover */
  source: Nullable<ExperimentTakeoverSource>;
};

export type ExperimentTakeoverStatus = {
  isModalOpen: boolean;
  isDrawerOpen: boolean;
};

export enum EXPERIMENT_CREATION_FORM_INPUT {
  NAME = 'name',
  TYPE = 'type',
}
